<template>
  <div class="createPdfbox">
    <div class="pdf_funcBar list-unstyled">
      <button type="button"
              id="btnToBack"
              class="btn btn_setting"
              @click="funcToBack">{{ $t('diagnosis.confirmPDF.btnToBack') }}</button>
    </div>
    <div class="pdf_workPlace">
      <Loading></Loading>
      <div id="pdfCreateArea">
        <div class="page_serviceRecord">
          <div class="print_logo">
            <img src="@/assets/images/comfirmlogo.png"
                 alt="Logo">
            <p>{{ $t('diagnosis.confirmPDF.logotitle') }}</p>
          </div>
          <div class="review_bikeInfo">
            <section>
              <ul class="list_titleStyle list-unstyled">
                <li :data-tit="$t('diagnosis.confirmPDF.bikeInfo.establish')">{{ reviewList.Date }}</li>
                <li :data-tit="$t('diagnosis.confirmPDF.bikeInfo.odo')">{{ getAllBikeInfoList.bikeInfoList.ODO }}</li>
                <li :data-tit="$t('diagnosis.confirmPDF.bikeInfo.bikeModel')">{{ reviewList.BikeModel }}</li>
                <li :data-tit="$t('diagnosis.confirmPDF.bikeInfo.frameNumber')">{{ reviewList.FrameNo }}</li>
              </ul>
            </section>
          </div>
          <div class="mt30">
            <div class="pdf_riding">
              <div class="titlebar_yellowIcons">
                <i class="icon-bike_cofirm"></i>
                <h3>{{ $t('diagnosis.confirmPDF.riding.title') }}</h3>
              </div>
              <ul class="list_titleStyle list-inline">
                <li :data-tit="$t('diagnosis.confirmPDF.riding.summary.totalDist')">{{ getAllBikeInfoList.bikeInfoList.ODO }} km</li>
                <li :data-tit="$t('diagnosis.confirmPDF.riding.summary.maximumSpeed')">{{ getAllBikeInfoList.bikeInfoList.MaxSpeed }} km/h</li>
                <li :data-tit="$t('diagnosis.confirmPDF.riding.summary.averageSpeed')">{{ getAllBikeInfoList.bikeInfoList.AvgSpeed }} km/h</li>
              </ul>
              <div class="rid_info">
                <ve-pie height="280px"
                        :data="chartData"
                        :colors="colors"
                        :settings="chartSettings"
                        :tooltip="tooltip"
                        :legend="legend"
                        :extend="chartExtend"
                        :events="chartEvents"></ve-pie>
                <table class="table table_base table_ride">
                  <thead>
                    <tr>
                      <th>{{ $t('diagnosis.confirmPDF.riding.table.mode') }}</th>
                      <th>{{ $t('diagnosis.confirmPDF.riding.table.km') }}</th>
                      <th>{{ $t('diagnosis.confirmPDF.riding.table.time') }}</th>
                      <th>{{ $t('diagnosis.confirmPDF.riding.table.avgSpeed') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in assistModeList"
                        :key="'KJH-'+item.Mode">
                      <td>{{ $t('diagnosis.confirmPDF.supportLevels.' + funcModeName(item.Mode)) }}</td>
                      <td>{{ item.KM }}</td>
                      <td>{{ item.Time }}</td>
                      <td>{{ item.AvgSpeed }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row mt30">
            <div class="col-sm-6">
              <div class="titlebar_yellowIcons">
                <i class="icon-confirm_battery"></i>
                <h3>{{ $t('diagnosis.confirmPDF.batteryStatus') }}</h3>
              </div>
              <ul class="list_hyphenStyle list-unstyled"
                  v-if="batteryStatus">
                <li>{{ $t('bikeOverview.bikeInformation.eBike.battery.stateOfCharge') }}： {{ batteryStatus.RSOC }}</li>
                <li>{{ $t('bikeOverview.bikeInformation.eBike.battery.stateOfHealth') }}： <span :class="healthClass">{{ $t('diagnosis.confirmPDF.health.' + healthLevel) }}</span></li>
              </ul>
            </div>
            <div class="col-sm-6">
              <div class="titlebar_yellowIcons">
                <i class="icon-confirm_record"></i>
                <h3>{{ $t('diagnosis.confirmPDF.advice.title') }}</h3>
              </div>
              <ul class="list_hyphenStyle list-unstyled">
                <li>{{ $t('diagnosis.confirmPDF.advice.nextMaintenance') }}： {{reviewList.NextODO}}km</li>
                <li>{{ $t('diagnosis.confirmPDF.advice.tipsOfBatteryUse') }}</li>
              </ul>
            </div>
          </div>
          <div class="row mt30">
            <div class="col-sm-12">
              <div class="titlebar_yellowIcons">
                <i class="icon-confirm_record"></i>
                <h3>{{ $t('diagnosis.createReport.workRecord.title') }}</h3>
              </div>
              <ul class="list_hyphenStyle list-unstyled"
                  v-if="todayWork">
                <li>{{ $t('diagnosis.createReport.workRecord.maintenance') }}： {{ reviewList.CurrODO }}km {{ $t('diagnosis.createReport.workRecord.confirmed') }} ({{ $t('diagnosis.createReport.workRecord.Actual') }} {{reviewList.NextODO}}km)</li>
                <li>{{ $t('diagnosis.createReport.workRecord.systemDiagnosis') }}： {{ todayWork.SystemDiagnosis }}</li>
              </ul>
            </div>
          </div>
          <!-- <div class="row mt30">
            <div class="col-sm-12">
              <div class="titlebar_yellowIcons">
                <i class="icon-confirm_record"></i>
                <h3>{{ $t('diagnosis.confirmPDF.advice.title') }}</h3>
              </div>
              <ul class="list_hyphenStyle list-unstyled">
                <li>{{ $t('diagnosis.confirmPDF.advice.nextMaintenance') }}： {{reviewList.NextODO}}km</li>
                <li>{{ $t('diagnosis.confirmPDF.advice.tipsOfBatteryUse') }}</li>
              </ul>
            </div>
          </div> -->
          <div class="row mt30 mb30">
            <div class="col-sm-7 col-sm-offset-5">
              <ul class="table_price list_titleStyle list-unstyled">
                <li :data-tit="$t('diagnosis.confirmPDF.confirmSign')">
                  <p></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- 顯示PDF -->
      <div id="pdfViewArea"></div>
    </div>
  </div>
</template>

<script>
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { mapGetters } from 'vuex';
import { GMTtoLocalTime } from '@/utils/date-format';
import { objHealthClass, objHealthTextKeys, funcGetHealthLevel } from '@/utils/batteryHealth';
import moment from 'moment';
import Loading from '@/components/Loading';

export default {
  name: 'PdfConfirm',
  data () {
    this.chartExtend = {
      animation: false,
      series: {
        center: ['50%', '50%'],
        itemStyle: {
          opacity: 1,
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    };
    this.chartSettings = {
      labelLine: {
        show: true,
        lineStyle: {
          color: 'black'
        }
      },
      label: {
        show: true,
        formatter: '{b} - {d}%',
        color: 'black'
      },
      radius: 80,
      hoverAnimation: false
    };
    this.legend = {
      show: false
    };
    this.tooltip = {
      formatter (e) {
        return e.name + ': ' + e.value + '%';
      }
    };
    this.chartEvents = {
      finished: () => {
        this.createPdf();
      }
    };
    return {
      colors: ['#e9ebec', '#909295', '#6c787e', '#3d464a', '#2d2d2d'],
      chartData: {
        columns: ['name', 'value'],
        rows: []
      },
      show: false,
      isDisabled: false,
      allAssistMode: {
        0: 'noAssistance',
        1: 'eco',
        2: 'tour',
        3: 'sport',
        4: 'highSpeed'
      }
    };
  },
  components: {
    Loading
  },
  mounted () {
    this.renderChartData();
  },
  watch: {
    getLang (val) {
      $('#pdfCreateArea, .anime_loading').show();
      this.renderChartData();
    }
  },
  computed: {
    ...mapGetters({
      // getUser: 'user/getUser',
      getCurrentDate: 'bikeConnect/getCurrentDate',
      getBikeFrameNo: 'bikeConnect/getBikeFrameNo',
      getLang: 'bikeConnect/getLang',
      getReportData: 'bikeReport/getReportData',
      getAllBikeInfoList: 'bikeInformation/getAllBikeInfoList',
      getBikeModel: 'bikeInformation/getBikeModel'
    }),
    reviewList () {
      return {
        Date: this.getCurrentDate,
        CurrODO: this.getAllBikeInfoList.bikeInfoList.ODO,
        NextODO: this.getAllBikeInfoList.bikeInfoList.NextMaintenance,
        BikeModel: this.getBikeModel || '--',
        FrameNo: this.getBikeFrameNo || '--',
        TodayWork: this.getReportData === null ? '--' : this.getReportData.TodayWork
      };
    },
    todayWork () {
      const obj = this.reviewList.TodayWork;
      for (let key in obj) {
        if (obj[key] === '') obj[key] = '--';
      }
      return obj;
    },
    batteryStatus () {
      return this.getAllBikeInfoList.bikeBatteryInfo;
    },
    assistModeList () {
      return this.getAllBikeInfoList.bikeInfoList.AssistMode;
    },
    filteredData () {
      const arr = this.destructure.filter(item => {
        return item instanceof Array;
      });
      return [].concat(...arr);
    },
    filteredItem () {
      return this.filteredData
        .filter(item => {
          return Object.keys(item).includes('ItemNo');
        });
    },
    healthLevel () {
      const strHealthLevel = funcGetHealthLevel(this.batteryStatus.Health);
      return strHealthLevel;
    },
    healthName () {
      const strHealthText = objHealthTextKeys[this.healthLevel];
      return strHealthText;
    },
    healthClass () {
      const strHealthClass = objHealthClass[this.healthLevel];
      return strHealthClass;
    }
  },
  methods: {
    renderChartData () {
      const tmpData = [];
      this.assistModeList.forEach((item, index) => {
        tmpData.push(
          {
            name: this.$t(`diagnosis.confirmPDF.supportLevels.${this.allAssistMode[item.Mode]}`),
            value: item.KM
          }
        );
      });
      this.chartData.rows = tmpData;
    },
    funcToBack () {
      this.$router.push('/service-tools/diagnosis');
    },
    funcDateFormat (date) {
      const formatDate = new Date(GMTtoLocalTime(date)); // eslint-disable-line new-cap
      return moment(formatDate).format('YYYY/MM/DD');
    },
    funcModeName (name) {
      switch (name.toString()) {
        case '0':
          return 'noAssistance';
        case '1':
          return 'eco';
        case '2':
          return 'tour';
        case '3':
          return 'sport';
        case '4':
          return 'highSpeed';
      }
    },
    funcHealthName (data) {
      // 電池健康度, 回傳語系 Key 值
      if (data >= 76 && data <= 100) return 'eBike.battery.health.good';
      else if (data >= 51 && data <= 75) return 'eBike.battery.health.average';
      else if (data <= 50) return 'eBike.battery.health.bad';
      else return data;
    },
    createPdf (quality = 2) {
      /* eslint new-cap: ["error", { "newIsCapExceptions": ["jsPDF"] }] */
      const pdf = new jsPDF('p', 'mm', 'a4', true);
      const PageWidth = pdf.internal.pageSize.getWidth();
      const PageHeight = pdf.internal.pageSize.getHeight();
      const width = PageWidth - 10;
      const height = PageHeight - 10;
      const oldIframeContainer = document.querySelector('.html2canvas-container');
      const oldIframePdfViewArea = document.querySelector('#pdfViewArea iframe');

      // remove old iframe
      if (oldIframeContainer) {
        document.querySelector('.html2canvas-container').remove();
      }
      if (oldIframePdfViewArea) {
        document.querySelector('#pdfViewArea iframe').remove();
      }
      html2canvas(document.getElementById('pdfCreateArea'),
        {
          scale: quality,
          useCORS: true,
          imageTimeout: 0,
          removeContainer: false,
          width: 800
        }
      ).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const iframe = document.createElement('iframe');
        pdf.addImage(imgData, 'PNG', 5, 5, width, height);
        iframe.setAttribute('style', 'position: absolute; left: 0; right:0; top:0; bottom:0; height: calc(100vh - 112px); width: 100%; border: none;');
        document.getElementById('pdfViewArea').appendChild(iframe);
        iframe.src = pdf.output('bloburi');
        $('#pdfCreateArea, .anime_loading').fadeOut(1000);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@charset "UTF-8";
.createPdfbox {
  margin-left: -15px;
  margin-right: -15px;
}
.pdf_funcBar {
  background-color: $grey;
  @include flexbox(flex, nowrap, space-between, center);
  padding: 10px;
  .btn_setting {
    padding: 6px 12px;
    transition: 0.2s linear;
  }
}
#pdfCreateArea {
  overflow: hidden;
  .page_serviceRecord {
    width: 800px;
    .pdf_riding {
      .rid_info .table_ride {
        thead {
          tr {
            th {
              &:last-child {
                text-align: center;
              }
            }
          }
        }
        tbody {
          tr {
            td {
              &:last-child {
                text-align: center;
              }
            }
          }
        }
      }
      .list_titleStyle {
        @include flexbox(flex, nowrap, space-between, center);
        margin: 15px 0;
        li {
          margin-bottom: 0;
        }
      }
    }
  }
}
.pdf_workPlace {
  position: relative;
  .print_logo {
    text-align: center;
    padding: 5px 0;
    img {
      width: 150px;
    }
    p {
      @include rem(font-size, 1.8rem);
      letter-spacing: 2px;
      text-indent: 2px;
      margin-top: 6px;
      margin-bottom: 0;
    }
  }
  .review_bikeInfo {
    .list_titleStyle {
      @include rem(font-size, 1.6rem);
    }
  }
  .list_hyphenStyle {
    padding: 15px;
  }
  .table_price {
    margin-top: 10px;
    > li {
      grid-template-columns: 220px auto;
      margin-top: 20px;
      p {
        border-bottom: 1px solid $black;
        margin-bottom: 0;
      }
    }
  }
}
</style>
